$.view.addHelper({
	/**
	 * Encode string for URI usage
	 *
	 * @returns {String}
	 */
	encode: function() {
		return encodeURIComponent(this.val);
	},

	/**
	 * Format date into standard output
	 *
	 * @returns {String}
	 */
	formatDate: function() {
		return new Date(this.val)
			.toLocaleDateString('en-us', {
				day: 'numeric',
				month: 'long',
				year: 'numeric'
			});
	},

	/**
	 * Return the number of items in the current collection
	 *
	 * @returns {Number}
	 */
	length: function() {
		return $.toArray(this.val).length;
	},

	/**
	 * Determine if a value is greater than a given number
	 *
	 * @param {Number} num
	 * @returns {Boolean}
	 */
	gt: function(num) {
		return parseFloat(this.val) > num;
	},

	/**
	 * Determine if a value is less than a given number
	 *
	 * @param {Number} num
	 * @returns {Boolean}
	 */
	lt: function(num) {
		return parseFloat(this.val) < num;
	},

	/**
	 * Join array values into list
	 *
	 * @returns {String}
	 */
	join: function() {
		return this.val ?
			this.val.join('\n') : '';
	}
});